var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PICTab_width, _PICTab_height;
import { css, html } from 'lit';
import { base64DecoderJSON, customElement, fetchWithFormData, PIC, PICBase, stringDecoder } from '../Internals';
import { json2Formdata } from '../../util/Util';
import { property, query } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
let PICTab = class PICTab extends PICBase {
    set width(iwidth) {
        let widthParser = '100%';
        if (iwidth) {
            if (typeof iwidth == 'number' || iwidth.match(/^-?[0-9]*$/g)) {
                iwidth = parseFloat(iwidth); // maybe change to Number(iwidth) ??
                widthParser = iwidth + 'px';
            }
            else
                widthParser = iwidth;
        }
        __classPrivateFieldSet(this, _PICTab_width, widthParser, "f");
        this.requestUpdate();
    }
    get width() {
        return __classPrivateFieldGet(this, _PICTab_width, "f");
    }
    set height(iheight) {
        let heightParser = '20%';
        if (iheight) {
            if (typeof iheight == 'number' || iheight.match(/^-?[0-9]*$/g)) {
                iheight = parseFloat(iheight);
                heightParser = iheight + 'px';
            }
            else
                heightParser = iheight;
        }
        __classPrivateFieldSet(this, _PICTab_height, heightParser, "f");
        this.requestUpdate();
    }
    get height() {
        return __classPrivateFieldGet(this, _PICTab_height, "f");
    }
    constructor() {
        super();
        _PICTab_width.set(this, void 0);
        _PICTab_height.set(this, void 0);
        this.parser = new DOMParser();
        this.backendActiveTab = '';
        this.cssStrings = [];
    }
    focus() {
    }
    validateSubmit() {
        return true;
    }
    get submitValue() {
        return this.activeTab.Id;
    }
    checkAndConsumeInlineData() {
        var _a;
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            this.mainTab = base64DecoderJSON(iData);
            if (this.mainTab.Tabs && this.mainTab.Tabs.length > 0) {
                (_a = this.mainTab.Tabs) === null || _a === void 0 ? void 0 : _a.map(tab => this.bodyDecider(tab));
                this.activeTab = this.mainTab.Tabs[0];
            }
            this.requestUpdate();
        }
        this.removeAttribute('datafromprogress');
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkAndConsumeInlineData();
        if (this.isinput__)
            window.PIC.addInput(this.id_, this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.PIC.removeInput(this.id_);
    }
    firstUpdated() {
        var _a, _b, _c;
        if (this.backendActiveTab) {
            let setFromBackend = (_a = this.mainTab.Tabs) === null || _a === void 0 ? void 0 : _a.find(tb => tb.Id === this.backendActiveTab);
            if (setFromBackend)
                this.bodyDecider(setFromBackend);
        }
        let cssElmCandidates = (_b = document.querySelector('head')) === null || _b === void 0 ? void 0 : _b.getElementsByTagName('link');
        if (cssElmCandidates)
            for (let link of cssElmCandidates) {
                if ((_c = link.getAttribute('href')) === null || _c === void 0 ? void 0 : _c.startsWith('/css')) {
                    this.cssStrings.push(link.getAttribute('href'));
                }
            }
        //needs this to calculate correct height for body
        //if the tabHolder height is static, this can be changed to a static calc method with variables
        if (this.tabHolder && this.bodyHolder)
            this.requestUpdate();
    }
    static get styles() {
        const defaultStyle = css `
    :host {
    }
    .outerContainer {
        width: 400px;
        height: 400px;
    }
    .tabs{
          display: flex;
          justify-content: start;
    }
    .tab {
        border: 1px solid var(--pic-outline);
        border-radius: 4px 4px 0 0;
        padding: 8px;
        border-bottom: 0;
    }
    .tab:hover {
        cursor: pointer;
    }
    .tab.disabled {
        pointer-events: none;
        color: var(--pic-onSurfaceDisabledColor);
    }
    .tab.disabled:hover {
        cursor: unset;
    }
    .body {
        border: 1px solid var(--pic-outline);
        width: 100%;
        height: 100%; /* actually 100% - .tabs:height */
        overflow: auto;
    }
    .tabBody body {
        margin: 8px;
    }
    .hidden {
        display: none;
    }
    .active {
        /* background-color: var(--pic-primaryColor); */
        background-color: var(--pic-tableMediumBgColor);
        color: var(--pic-onPrimaryColor, var(--pic-onPrimaryHighColor));
    }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    getFormData(tab) {
        let queryParms = {
            'eventid': 'load',
            'moduleId': 'modal', //This might need a different mode
            'Subwin': tab.ProgramPath,
            'SessionCode': PIC.getInstance.sessionCode,
        };
        return json2Formdata(queryParms);
    }
    fetchBodyData(tab) {
        let options = {
            formData: this.getFormData(tab),
            formatOutput: 'text'
        };
        fetchWithFormData(options).then(data => {
            this.bodyDOM = this.parser.parseFromString(data, 'text/html');
            tab.bodyElement = this.bodyDOM.querySelector('body');
        })
            .catch(err => console.log(err));
    }
    getClassTabBody(tab) {
        return {
            'tabBody': true,
            'hidden': tab !== this.activeTab,
        };
    }
    renderBody(tab) {
        return html `<div class=${classMap(this.getClassTabBody(tab))}>
            ${tab.bodyElement}
        </div>
    `;
    }
    convertBodyData(tab) {
        try {
            if (tab.addComponents) {
                this.bodyDOM = this.parser.parseFromString(atob(tab.addComponents), 'text/html');
                tab.bodyElement = this.bodyDOM.querySelector('body');
            }
        }
        catch (_a) {
        }
    }
    bodyDecider(tab) {
        this.activeTab = tab;
        if (!tab.bodyElement) {
            if (tab.ProgramPath)
                this.fetchBodyData(tab);
            else if (tab.addComponents)
                this.convertBodyData(tab);
        }
        this.requestUpdate();
    }
    handleTabButtonClick(e, tab) {
        this.bodyDecider(tab);
    }
    getClassMapHdr(tab) {
        return {
            'tab': true,
            'pic-overline': true,
            'active': this.activeTab === tab,
            'disabled': tab.Disabled ? true : false,
            'no-select': true
        };
    }
    renderMapHdr(tab) {
        return html `<div tabindex=${tab.Disabled ? '-1' : ''} class=${classMap(this.getClassMapHdr(tab))} @click=${(e) => this.handleTabButtonClick(e, tab)}>${tab.Label}</div>`;
    }
    getComponentStyle() {
        let styles = [];
        if (this.width) {
            styles.push({ 'min-width': this.width });
            styles.push({ 'width': this.width });
            styles.push({ 'max-width': this.width });
        }
        if (this.height) {
            styles.push({ 'min-height': this.height });
            styles.push({ 'height': this.height });
            styles.push({ 'max-height': this.height });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getBodyStyle() {
        let styles = [];
        if (this.tabHolder && this.bodyHolder) {
            let tabHolderHeight = this.tabHolder.offsetHeight;
            let bodyBorderWidth = 2;
            styles.push({ 'height': `calc(100% - ${tabHolderHeight + bodyBorderWidth}px)` });
        }
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    render() {
        var _a, _b;
        return html `
        ${this.cssStrings.map(css => this.renderCSSLink(css))}
        <div class="outerContainer"
            style=${styleMap(this.getComponentStyle())} 
        >
            <div class="tabs">${(_a = this.mainTab.Tabs) === null || _a === void 0 ? void 0 : _a.map(tab => this.renderMapHdr(tab))}</div>
            <div class="body" style=${styleMap(this.getBodyStyle())} >
                ${(_b = this.mainTab.Tabs) === null || _b === void 0 ? void 0 : _b.map(tab => this.renderBody(tab))}
            </div>
        </div>
    `;
    }
};
_PICTab_width = new WeakMap();
_PICTab_height = new WeakMap();
__decorate([
    property({ type: String, attribute: 'width', reflect: true })
], PICTab.prototype, "width", null);
__decorate([
    property({ type: String, attribute: 'height', reflect: true })
], PICTab.prototype, "height", null);
__decorate([
    property({ converter: stringDecoder, attribute: 'activetab', reflect: false })
], PICTab.prototype, "backendActiveTab", void 0);
__decorate([
    query('.tabs')
], PICTab.prototype, "tabHolder", void 0);
__decorate([
    query('.body')
], PICTab.prototype, "bodyHolder", void 0);
PICTab = __decorate([
    customElement('pic-tab')
], PICTab);
export { PICTab };
//# sourceMappingURL=PICTab.js.map